module.exports = __webpack_public_path__ + "static/discord-91b32c610da6a82c6ee0316c1fcf3463.png";